import React, { useEffect } from 'react';
import { Button, SelectablePanelGroup } from 'mesh-component-library';
import { useDispatch } from 'react-redux';
import Constants from '../../../env/constants';
import { useClaimInfoSelector } from '../../../redux/hooks/useClaimInfoSelector';
import { useRouteProps } from '../../../redux/hooks/useRouteProps';
import { setLoadingModalFlagAction } from '../../../redux/reducers/actions';
import useClaimData from '../../../redux/hooks/useClaimData';

const AssetSelectionPage: React.FC = () => {
    const claim = useClaimData();
    const setSelectedClaimInfo = useClaimInfoSelector();
    const dispatch = useDispatch();
    const { text, onClick } = useRouteProps();
    const isClaimInfoSelectionButtonDisabled = claim.selectedClaimInfoIndex === null;

    const radioOptions = claim.claimInfoLinkList.map(
        ({ make, model, year, streetAddress, city, state }: ClaimInfoLink, index: number) => ({
            key: index,
            defaultChecked: claim.selectedClaimInfoIndex !== null && index === claim.selectedClaimInfoIndex,
            id: `asset-${index}`,
            value: index,
            text: !streetAddress ? `${year} ${make} ${model}` : `${streetAddress} ${city}, ${state}`,
            showInput: true,
            onChange: setSelectedClaimInfo,
        }),
    );

    useEffect(() => {
        dispatch(setLoadingModalFlagAction(false));
    }, [dispatch]);

    return (
        <div data-testid="asset-page-body" className="page-body">
            <section data-testid="asset-selection-page" className="body-section--asset">
                <div data-testid="asset-card">
                    <SelectablePanelGroup
                        name="selectAsset"
                        options={radioOptions}
                        required
                        type="radio"
                        isVertical
                        data-testid="asset-radio-buttons"
                    />
                    <div
                        data-testid="asset-selection-help-text"
                        className="help-text"
                        style={{ visibility: 'visible' }}
                    >
                        {Constants.helpMessage}
                    </div>
                </div>
                <div data-testid="asset-button-container">
                    <Button
                        hasUpgrade
                        variant="information"
                        onClick={onClick}
                        className="validation-button"
                        disabled={isClaimInfoSelectionButtonDisabled}
                    >
                        {text}
                    </Button>
                </div>
            </section>
        </div>
    );
};

export default AssetSelectionPage;
